import GuidelineDetailContainer from "./GuidelineDetailContainer";

export default GuidelineDetailContainer;
